import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./contactUs.css";
import Footer from "../../components/Footer/Footer";

export default class ContactUs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      consentGiven: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleCheckboxChange = (event) => {
    this.setState({ consentGiven: event.target.checked });
  };


  render() {
    return (
      <div>
        <div className="contatct-home">
          <section className="contatct-hero">
            <h1 className="contatct-hero-text">
              Got an Idea? <br />
              We’ll <span className="highlight">Make It Real. </span>
            </h1>
            <p className="contatct-subtext">
              Whether you’re looking to build a cutting-edge app, supercharge your brand, or explore digital <br />transformation,
              our team is ready to collaborate. Fill out the form and we’ll get back to you within 24 hours.
            </p>
          </section>
          <form className="contact-form">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" placeholder="Enter your full name" />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" placeholder="Enter your email address" />
              </div>
              <div className="form-group">
                <label>Contact Number</label>
                <input type="text" placeholder="Enter your contact number" />
              </div>
            </div>

            <div className="form-group">
              <label>Project Type</label>
              <select>
                <option>Select Project Type</option>
                <option>Web Development</option>
                <option>Mobile App</option>
                <option>Digital Marketing</option>
                <option>Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Tell Us About Your Project</label>
              <textarea rows="4" placeholder="Describe your project..."></textarea>
            </div>
            <div className="form-group checkbox-group">
              <label className="checkbox-wrapper">
                <input type="checkbox"
                  id="consent"
                  onChange={this.handleCheckboxChange} />
                I agree to give the above personal data to Ambrum. Ambrum may use the data to evaluate,
                store for further processing and use anonymised data to train our models <br /> to improve our
                recruitment process.
              </label>
            </div>

            <Link to={this.state.consentGiven ? "/thankyou" : "#"}>
              <button type="button"
                className="submit-button"
                disabled={!this.state.consentGiven}>Submit</button>
            </Link>
          </form>

        </div>
        <Footer />
      </div>

    );
  }
}
